import "./BeechCaseStudyPage.scss";
import barnImage from "../../assets/images/beech-nurseries-logo-design-on-weathered-barn.webp";
import manFence from "../../assets/images/man-standing-at-beech-nurseries.webp";
import primaryBeechColours from "../../assets/images/brand-design-services-primary-color-palette.webp";
import truckWrap from "../../assets/images/beech-nurseries-truck-wrap-design.webp";
import priceList from "../../assets/images/coil-bound-book-mockup-graphic-design.webp";
import secondaryBeechColours from "../../assets/images/brand-design-secondary-colour-palette.webp";
import priceListMockup from "../../assets/images/mockup-coil-bound-book-brantford-graphic-design.webp";
import tradeShowPanorama from "../../assets/images/brand-logo-design-tradeshow-display-horticulture.webp";
import tradeShowBanners from "../../assets/images/beech-nurseries-trade-show-banner-display-greater-toronto-area.webp";
import ContactMe from "../../components/ContactMe/ContactMe";

export default function BeechCaseStudyPage() {
return (
<div className="case-study">
{/* Full-width Header */}
<section className="case-study__hero">
<img
src={barnImage}
alt="Weathered barn in a green field with the Beech Nurseries logo painted on the siding and a vintage tractor in front."
className="case-study__hero-image"
/>
</section>


{/* Two-column Layout */}
<section className="case-study__overview">
<div className="case-study__overview-left">
<h1>Beech Nurseries</h1>
<h2>Logo and Brand Refresh</h2>


<ul className="case-study__overview-list">
<li>Brand Identity</li>
<li>Logo Design</li>
<li>Tradeshow Banners</li>
<li>Product Catalogue</li>
<li>Swag</li>
</ul>
</div>


<div className="case-study__overview-right">
<h5>
Beech Nurseries needed a modern brand refresh to showcase their full
scope of business: a tree farm, wholesale operations, tree spading,
and a retail nursery in the charming village of Schomberg, Ontario.
</h5>
<br></br>
<h5>
I created a new logo and visual identity inspired by the elegant shape
of the beech leaf—an iconic tree they wholesale. The result is a clean,
versatile logo system that feels both natural and professional.
</h5>
<br></br>
<h5>
The refreshed identity was applied across digital and print touchpoints,
including their website, marketing materials, and branded swag. This cohesive
look not only elevates their presence but also reflects the craftsmanship
and care behind their work.
</h5>
<br></br>
<h5>
As a graphic designer specializing in logo design, brand identity, and
marketing visuals, I help businesses grow with designs that are meaningful,
memorable, and market‑ready.
</h5>
</div>
</section>

<section className="case-study__hero">
<img
src={manFence}
alt="Smiling man in a plaid shirt and Beech Nurseries cap leaning on a wooden fence, with autumn trees and a sunlit field in the background."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
src={primaryBeechColours}
alt="Beech Nurseries primary color palette showing four brand colors: green, black, light beige, and warm tan, each displayed with the Beech Nurseries leaf logo in the center."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
src={truckWrap}
alt="A woman wearing gloves, a plaid shirt, and a beanie stands outdoors holding a shovel in front of rows of trees. Beside her, a white pickup truck is parked on a dirt path, with autumn trees in the background."
className="case-study__hero-image"
/>
</section>

{/* Two-column Layout */}
<section className="case-study__overview">
<div className="case-study__overview-left">
<h1>Colour Palette</h1>
<h2>Brand Development</h2>

</div>

  <div className="case-study__overview-right">
    <h5>
      I created a colour palette inspired by the vibrant hues of nature, drawing from seasonal gardens with rich bark tones, floral shades, and fruit-inspired accents. Together, these colors form a versatile system that adds depth, warmth, and vibrancy to the brand.
    </h5>
    <br />
    <h5>
      This palette highlights the natural beauty and diversity of cultivated gardens, giving Beech Nurseries a fresh yet timeless identity. It was applied across multiple touchpoints, including a professionally designed wholesale price list that I prepared for print, ensuring brand consistency in both digital and print materials.
    </h5>
    <br />
    <h5>
      As a graphic designer specializing in branding, colour systems, and print design, I focus on building palettes that not only look stunning but also work seamlessly across every platform a business needs.
    </h5>
  </div>
</section>

<section className="case-study__hero">
<img
src={secondaryBeechColours}
alt="Six color blocks arranged in a grid, showing the secondary color palette: blue, brick red, teal, magenta, mustard, and purple."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
src={priceList}
alt="Coil-bound catalog standing upright on a wooden surface, with the cover showing the Beech Nurseries logo, a wooden fence, and autumn trees in the background. The text reads “2025 Wholesale Price List."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
src={priceListMockup}
alt="Open coil-bound catalog pages laid out on a flat surface, showing plant photographs, species names, and price lists for trees, shrubs, and evergreens."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
src={tradeShowPanorama}
alt="Trade show display with the Beech Nurseries logo on a large black banner framed by wood beams. Evergreen trees, bare saplings, and flowering plants surround the setup, with tables and chairs arranged on artificial grass in the foreground."
className="case-study__hero-image"
/>
</section>

<section className="case-study__hero">
<img
  src={tradeShowBanners}
  alt="Two large trade show banners displayed between tall evergreen trees. The left banner lists services as a wholesaler of premium plant material, and the right banner promotes mature tree spading, planting, and moving with a truck carrying a tree."
  className="case-study__hero-image"
/>

</section>
 <ContactMe />
</div>
    
);
}